import {NgModule} from '@angular/core';
import {ReportConverter} from './api/entity/converter/report.converter';
import {ReportSummaryConverter} from './api/entity/converter/reportSummary.converter';
import {ReportRecipientConverter} from './api/entity/converter/reportRecipient.converter';
import {ReportCommunicationContentConverter} from './api/entity/converter/reportCommunicationContent.converter';
import {
    EmbeddedReportModelFieldInputTypeHandlerModule
} from './impl/component/form-definition-field-type-handler/embedded-report-model-field-input-type-handler/embedded-report-model-field-input-type-handler.module';
import {
    EmbeddedReportModelFieldInputTypeHandlerComponent
} from './impl/component/form-definition-field-type-handler/embedded-report-model-field-input-type-handler/embedded-report-model-field-input-type-handler.component';
import {
    FieldInputTypeHandlerRegister
} from '../../../components/common/field/field-input/type-handler/IFieldInputTypeHandler';
import {FormDefinitionFieldType} from '../../form/definition/field/api/entity/formDefinitionFieldSummary.model';

@NgModule({
    imports: [
        EmbeddedReportModelFieldInputTypeHandlerModule,
    ]
})
export class ReportingReportModule {
    constructor() {
        FieldInputTypeHandlerRegister.register(EmbeddedReportModelFieldInputTypeHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_EMBEDDED_FILE,
            'FORM_DEFINITION_FIELD_SUBTYPE_REPORT_MODEL');
    }
}
